document.addEventListener('DOMContentLoaded', () => {
  const filterList = document.querySelectorAll('.select-list li');
  if (!filterList.length) return;

  const urlParams = new URLSearchParams(window.location.search);
  const currentCat = urlParams.get('cat');

  if (currentCat) {
    filterList.forEach(li => {
      if (li.dataset.value === currentCat) {
        li.classList.add('active');
      }
    });
  }

  const postsWrap = document.getElementById('project-posts-wrap');
  if (!postsWrap) return;

  let loading = false;
  let noMore = false;
  let category = currentCat || '';

  // WPML language
  const langCookie = document.cookie.split('; ').find(item => item.startsWith('wp-wpml_current_language='));
  const lang = langCookie ? langCookie.split('=')[ 1 ] : null;

  async function fetchMoreProjects() {
    if (loading || noMore) return;
    loading = true;

    const offset = postsWrap.querySelectorAll('.col-12').length;

    const data = new FormData();
    data.append('action', 'noorproject');
    data.append('offset', offset);
    data.append('post_format', category);
    if (lang) data.append('lang', lang);

    const loader = document.createElement('div');
    loader.className = 'loading';
    loader.innerHTML = `<div class="spinner-border" role="status"><span class="visually-hidden">Loading...</span></div>`;
    postsWrap.appendChild(loader);

    try {
      const response = await fetch(ajax_params.ajax_url, { method: 'POST', body: data });
      const result = await response.json();

      if (!result.content || result.content.trim() === '') {
        noMore = true;
      } else {
        postsWrap.insertAdjacentHTML('beforeend', result.content);
      }
    } catch (err) {
      console.error('Error fetching projects:', err);
    } finally {
      loader.remove();
      loading = false;
    }
  }

  function handleScroll() {
    const rect = postsWrap.getBoundingClientRect();
    if (!loading && !noMore && (rect.bottom - 200 <= window.innerHeight)) {
      fetchMoreProjects();
    }
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);

  // ========================
  // Filter Click Handler
  // ========================
  filterList.forEach(li => {
    li.addEventListener('click', () => {
      const selected = li.dataset.value;
      const isActive = li.classList.contains('active');

      filterList.forEach(item => item.classList.remove('active'));

      if (!isActive) {
        li.classList.add('active');
        category = selected;
        urlParams.set('cat', selected);
      } else {
        category = '';
        urlParams.delete('cat');
      }

      // Update URL
      const newUrl = window.location.pathname + '?' + urlParams.toString();
      history.pushState(null, '', newUrl);

      postsWrap.innerHTML = '';
      noMore = false;
      loading = false;

      fetchMoreProjects();
    });
  });

  if (category) {
    fetchMoreProjects();
  }
});